<template>
  <div>
    <recordHeader :customerInfo="customerInfo" />
    <div style="padding-top: 120px;" :class="openHistory?'report openHistory':'report closeHistory'">
      <historyTable :recordList="recordList" :data="data" class="table" v-if="openHistory" @copy="copy" @copyPrescription="copyPrescription" @compareCase="compareCase" />
      <div class="table">
        <table border="1">
          <tbody>
            <!-- 主诉 -->
            <tr>
              <th>*主诉*
                <!-- <a-button size="small" class="block">记录变化</a-button> -->
              </th>
              <td colspan="2" class="bg-light">
                <a-input v-model:value="inputs.chiefComplaint" placeholder="主诉" />
              </td>
            </tr>
            <tr>
              <th>
                标准症候群
                <a-button size="small" class="block" @click="toHealthAssessment">导入小医微测记录</a-button>
              </th>
              <td colspan="2">

                <div class="popconfirm">
                  <a-select v-model:value="inputs.syndrome" show-search placeholder="中文或首字母" allowClear :filterOption="filterName" size="small" style="width: 180px;margin-left: 15px;" @change="handleChangePopconfirm(inputs.syndrome, '症候群')">
                    <a-select-option v-for="item in syndromeOption" :value="item.name">{{ item.name }}</a-select-option>
                  </a-select>
                  <div class="box" v-if="showSyndromePop">
                    <h5>{{inputs.syndrome}}</h5>
                    <div class="content">
                      <div v-for="(item,index) in setting">
                        <a-select v-if="item.valueType==='List'" v-model:value="details[index].diagnosisInfo" :placeholder="item.diagnosisName" size="small" style="width: 180px;">
                          <a-select-option v-for="item in item.list" :value="item">{{item}}</a-select-option>
                        </a-select>
                        <a-input size="small" v-else-if="item.valueType==='String'" v-model:value="details[index].diagnosisInfo" :placeholder="item.diagnosisName" />
                      </div>

                    </div>
                    <div class="btnBox">
                      <a-button size="small" @click="insertToList('症候群')" type="primary">插入</a-button>
                      <a-button size="small" @click="showSyndromePop=false">取消</a-button>
                    </div>
                  </div>
                </div>
                <div class="list">
                  <div v-for="item in syndromeList" class="item" @click="editList(item, '症候群')">
                    <a-popconfirm title="是否确认删除" @confirm="deleteList(item.id)" okText="确认" cancelText="取消">
                      <CloseCircleOutlined style="color:red" />
                    </a-popconfirm>
                    <div v-if="editSyndromeListData?.id!=item.id">
                      <span title="点击编辑">{{item.projectName}}</span>
                      <p title="点击编辑" v-for="(item2,index) in item.details" class="row">
                        <span>{{item2.diagnosisName}}：</span>
                        <span>【{{item2?.diagnosisInfo}}】{{item.details.length!=index+1?"；":""}}</span>
                      </p>
                    </div>
                    <div v-else>
                      <span>{{item.projectName}}</span>
                      <div v-for="(item2,index) in editSetting">
                        <div v-if="editDetails.length!=0">
                          <span>{{item2.diagnosisName}}：</span>
                          <a-select v-if="item2.valueType==='List' " v-model:value="editDetails[index].diagnosisInfo" :placeholder="item2.diagnosisName" size="small" style="width: 180px;">
                            <a-select-option v-for="item in item2.list" :value="item">{{item}}</a-select-option>
                          </a-select>
                          <a-input size="small" style="display:inline-block;width: 200px;" v-else-if="item2.valueType==='String'" v-model:value="editDetails[index].diagnosisInfo" :placeholder="item2.diagnosisName" />
                        </div>
                      </div>
                      <a-button v-if="editDetails.length!=0" size="small" style="background-color: #1890ff;color: #fff;" @click="updateList(item2,item)">保存</a-button>
                      <a-button size="small" @click="resetList('症候群')">重置</a-button>
                    </div>

                  </div>
                </div>
              </td>
            </tr>
            <!-- 现病史 -->
            <tr>
              <th>现病史</th>
              <td colspan="2">
                <a-textarea v-model:value="inputs.presentIllnessHistory" placeholder="现病史" />
              </td>
            </tr>
            <!-- 既往史 -->
            <tr>
              <th>既往史</th>
              <td colspan="2">
                <a-textarea v-model:value="inputs.pastHistory" />
              </td>
            </tr>
            <!-- 其他 -->
            <tr>
              <th>其他</th>
              <td colspan="2">
                <a-input v-model:value="inputs.comment" placeholder="其他" />
              </td>
            </tr>
            <!-- 脉象 -->
            <tr>
              <th rowspan="4">脉象
                <a-button size="small" class="block" @click="toMaiZhenYi">导入未病智能分析仪记录</a-button>
              </th>
              <td>运脉</td>
              <td>
                <a-button size="small" @click="visible3=true">图选</a-button>
                <a-input style="width: 250px;margin-left: 20px;" v-model:value="inputs.tcmDiagnose" placeholder="输入1-2位脉象可以使用专家系统" />
              </td>
            </tr>
            <tr>
              <td>
                左寸脉
                <a-select v-model:value="inputs.leftCunType" allowClear style="width:100px;margin-right: 10px;" @change="handleChangePulse('leftCun')">
                  <!-- <a-select-option v-for="item in $store.state.areaNameType" :value="item.NAME">{{ item.NAME }}</a-select-option> -->
                  <a-select-option v-for="item in pulseOption" :value="item.pulse">{{item.pulse}}</a-select-option>
                </a-select>
                <a-input v-model:value="inputs.leftCun" style="width: 150px;" />
              </td>
              <td>
                右寸脉
                <a-select v-model:value="inputs.rightCunType" allowClear style="width:100px;margin-right: 10px;" @change="handleChangePulse('rightCun')">
                  <!-- <a-select-option v-for="item in $store.state.areaNameType" :value="item.NAME">{{ item.NAME }}</a-select-option> -->
                  <a-select-option v-for="item in pulseOption" :value="item.pulse">{{item.pulse}}</a-select-option>
                </a-select>
                <a-input v-model:value="inputs.rightCun" style="width: 150px;" />
              </td>
            </tr>
            <tr>
              <td>
                左关脉
                <a-select v-model:value="inputs.leftGuanType" allowClear style="width:100px;margin-right: 10px;" @change="handleChangePulse('leftGuan')">
                  <!-- <a-select-option v-for="item in $store.state.areaNameType" :value="item.NAME">{{ item.NAME }}</a-select-option> -->
                  <a-select-option v-for="item in pulseOption" :value="item.pulse">{{item.pulse}}</a-select-option>
                </a-select>
                <a-input v-model:value="inputs.leftGuan" style="width: 150px;" />
              </td>
              <td>
                右关脉
                <a-select v-model:value="inputs.rightGuanType" allowClear style="width:100px;margin-right: 10px;" @change="handleChangePulse('rightGuan')">
                  <!-- <a-select-option v-for="item in $store.state.areaNameType" :value="item.NAME">{{ item.NAME }}</a-select-option> -->
                  <a-select-option v-for="item in pulseOption" :value="item.pulse">{{item.pulse}}</a-select-option>
                </a-select>
                <a-input v-model:value="inputs.rightGuan" style="width: 150px;" />
              </td>
            </tr>
            <tr>
              <td>
                左尺脉
                <a-select v-model:value="inputs.leftChiType" allowClear style="width:100px;margin-right: 10px;" @change="handleChangePulse('leftChi')">
                  <!-- <a-select-option v-for="item in $store.state.areaNameType" :value="item.NAME">{{ item.NAME }}</a-select-option> -->
                  <a-select-option v-for="item in pulseOption" :value="item.pulse">{{item.pulse}}</a-select-option>
                </a-select>
                <a-input v-model:value="inputs.leftChi" style="width: 150px;" />
              </td>
              <td>
                右尺脉
                <a-select v-model:value="inputs.rightChiType" allowClear style="width:100px;margin-right: 10px;" @change="handleChangePulse('rightChi')">
                  <!-- <a-select-option v-for="item in $store.state.areaNameType" :value="item.NAME">{{ item.NAME }}</a-select-option> -->
                  <a-select-option v-for="item in pulseOption" :value="item.pulse">{{item.pulse}}</a-select-option>
                </a-select>
                <a-input v-model:value="inputs.rightChi" style="width: 150px;" />
              </td>
            </tr>
            <!-- 舌象 -->
            <tr>
              <th>舌象</th>
              <td colspan="2">
                <a-input v-model:value="inputs.tongue" placeholder="舌象" />
              </td>
            </tr>
            <!-- 伏病诊断 -->
            <tr>
              <th>*伏病诊断*</th>
              <td colspan="2" class="bg-light">
                <a-input v-model:value="inputs.fubingDiagnose" placeholder="伏病诊断" />
              </td>
            </tr>
            <!-- 西医诊断 -->
            <tr>
              <th rowspan="2">*西医诊断 *
              </th>
              <td colspan="2">
                <a-input v-model:value="inputs.wmDiagnose" placeholder="诊断" />
              </td>
            </tr>
            <tr>
              <td colspan="2">

                <div class="popconfirm">
                  <a-select v-model:value="inputs.disease" show-search placeholder="中文或首字母" allowClear :filterOption="filterName" size="small" style="width: 180px;margin-left: 15px;" @change="handleChangePopconfirm(inputs.disease, '疾病')">
                    <a-select-option v-for="item in diseaseOption" :value="item.name">{{ item.name }}</a-select-option>
                  </a-select>
                  <div class="box" v-if="showDiseasePop">
                    <h5>{{inputs.disease}}</h5>
                    <div class="content">
                      <div v-for="(item,index) in setting">
                        <a-select v-if="item.valueType==='List'" v-model:value="details[index].diagnosisInfo" :placeholder="item.diagnosisName" size="small" style="width: 180px;">
                          <a-select-option v-for="item in item.list" :value="item">{{item}}</a-select-option>
                        </a-select>
                        <a-input size="small" v-else-if="item.valueType==='String'" v-model:value="details[index].diagnosisInfo" :placeholder="item.diagnosisName" />
                      </div>

                    </div>
                    <div class="btnBox">
                      <a-button size="small" @click="insertToList('疾病')" type="primary">插入</a-button>
                      <a-button size="small" @click="showDiseasePop=false">取消</a-button>
                    </div>
                  </div>
                </div>
                <div class="list">
                  <div v-for="item in diseaseList" class="item" @click="editList(item, '疾病')">
                    <a-popconfirm title="是否确认删除" @confirm="deleteList(item.id)" okText="确认" cancelText="取消">
                      <CloseCircleOutlined style="color:red" />
                    </a-popconfirm>
                    <div v-if="editDiseaseListData?.id!=item.id">
                      <span title="点击编辑">{{item.projectName}}</span>
                      <p title="点击编辑" v-for="(item2,index) in item.details" class="row">
                        <span>{{item2.diagnosisName}}：</span>
                        <span>【{{item2.diagnosisInfo}}】{{item.details.length!=index+1?"；":""}}</span>
                      </p>
                    </div>
                    <div v-else>
                      <span>{{item.projectName}}</span>
                      <div v-for="(item2,index) in editSetting">
                        <div v-if="editDetails.length!=0">
                          <span>{{item2.diagnosisName}}：</span>
                          <a-select v-if="item2.valueType==='List'" v-model:value="editDetails[index].diagnosisInfo" :placeholder="item2.diagnosisName" size="small" style="width: 180px;">
                            <a-select-option v-for="item in item2.list" :value="item">{{item}}</a-select-option>
                          </a-select>
                          <a-input size="small" style="display:inline-block;width: 200px;" v-else-if="item2.valueType==='String'" v-model:value="editDetails[index].diagnosisInfo" :placeholder="item2.diagnosisName" />
                        </div>
                      </div>
                      <a-button v-if="editDetails.length!=0" size="small" style="background-color: #1890ff;color: #fff;" @click="updateList(item2,item)">保存</a-button>
                      <a-button size="small" @click="resetList('疾病')">重置</a-button>
                    </div>

                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <prescriptionTemplate ref="prescriptionTemplate" :prescriptionInfoList="prescriptionInfoList" :data="data" :openHistory="openHistory" :template="template" @getPrescriptionList="getPrescriptionList" />
          <tbody v-if="data.status=='Diagnosing'">
            <!-- 增加处方 -->
            <tr>
              <th>增加处方</th>
              <td colspan="2" class="btns">
                <a-button type="primary" @click="addPrescriptionInfo">手动</a-button>
                <a-button type="primary" @click="visible5=true">智能</a-button>
              </td>
            </tr>
          </tbody>
          <tbody v-if="template=='Simple_Futie'">
            <!-- 增加处方 -->
            <tr>
              <th>穴位处方</th>
              <td colspan="2">
                <a-textarea v-model:value="inputs.recipeAcupoint" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="buttonBox">
      <a-button v-for="item in operations" type="primary" @click="handleOperation(item)">{{item}}</a-button>
      <a-button type="primary" @click="save">保存</a-button>
      <!-- <a-button type="primary">打印</a-button> -->
      <a-button type="primary" @click="compareCase" :disabled="!canCompare">{{openHistory?"关闭对比":"病历对比"}}</a-button>
      <!-- <a-button type="primary">客情记录</a-button> -->
    </div>

  </div>

  <editCustomer v-model="visible" :customerInfo="customerInfo" @reSearch="getRecordDetail" />
  <maizhenyi v-model="visible2" :customerId="customerId" @maizhenyiCallback="maizhenyiCallback" />
  <wuxing v-model="visible3" @wuxingCallback="wuxingCallback" />
  <healthAssessment v-model="visible4" :customerId="customerId" :medicalRecordUuid="medicalRecordUuid" @healthAssessmentCallBack="healthAssessmentCallBack" />
  <autoPrescription v-model="visible5" :medicalRecordUuid="medicalRecordUuid" :id="data.id" :syndromeList="syndromeList" :reportId="reportId" :diseaseList="diseaseList" :tcmDiagnose="inputs.tcmDiagnose" @autoPrescriptionCallBack="autoPrescriptionCallBack" @refreshCallback="refreshCallback" :template="template" />

</template>

<style scoped>
.report {
}
.report .table {
  height: 78vh;
  overflow: auto;
  width: 65%;
  min-width: 1150px;
  margin: 0 auto;
  transition: 0.5s all;
}
.closeHistory {
  width: 100%;
}
.openHistory {
  display: flex;
  justify-content: space-around;
}
.openHistory .table {
  width: 49%;
  margin: 0;
}
.openHistory .table table {
  width: 100%;
}
textarea {
  resize: none;
}
.head {
  text-align: center;
  position: fixed;
  width: 100%;
  z-index: 9;
  background-color: #fff;
  border-bottom: 1px solid #ccc;
}
.table .row {
  display: flex;
  vertical-align: middle;
  align-items: center;
}
table {
  width: 100%;
  margin: 0 auto;
  border-color: #aaa;
  text-align: left;
}
tr {
  height: 40px;
}
tr:hover {
  background-color: #fff8e3;
}
th,
td {
  padding: 5px;
}
th {
  text-align: center;
  width: 250px;
}
.bg-light {
  background-color: #fcf8e3;
}
.ant-input {
  display: inline-block;
}
.bg-light .ant-input {
  border: none;
  background-color: #fcf8e3;
}
.ant-select {
  width: 250px;
}
.block {
  display: block;
  margin: 0 auto 5px;
}
.buttonBox {
  position: fixed;
  width: 100%;
  background-color: #fff;
  bottom: 0;
  display: flex;
  justify-content: center;
  /* flex-direction: column; */
}
.buttonBox .ant-btn {
  margin: 10px 10px;
}
.popconfirm {
  position: relative;
  display: inline-block;
}
.popconfirm .box {
  position: absolute;
  top: 100%;
  left: 50%;
  background-color: #f1fdff;
  transform: translate(-50%, 7px);
  border: 1px solid #ccc;
  padding: 10px;
  width: 300px;
  z-index: 10;
  box-shadow: 3px 3px 7px #00000052;
  border-radius: 10px;
}
/* popconfirm面的小三角 */
.popconfirm .box::after {
  content: "";
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate(-50%, -100%);
  border-width: 7px;
  border-style: solid;
  border-color: transparent transparent #ccc transparent;
}

.popconfirm .box h5 {
  border-bottom: 1px solid #999;
  padding-bottom: 8px;
  font-size: 16px;
  text-align: center;
  letter-spacing: 3px;
}
.popconfirm .box .content {
  margin-bottom: 10px;
}
.popconfirm .box .content > * {
  margin-bottom: 5px;
}
.popconfirm .btnBox {
  display: flex;
  justify-content: center;
}
.popconfirm .btnBox .ant-btn {
  margin-left: 10px;
}
.btns .ant-btn {
  margin-right: 5px;
}
.list .item {
  position: relative;
}
.list .item > div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-left: 28px;
  position: relative;
  padding: 2px 0px 2px 15px;
  cursor: pointer;
}
.list .item .anticon {
  position: absolute;
  margin: 0;
  top: 50%;
  left: 0px;
  transform: translateY(-50%);
  z-index: 1;
}
.list .item .anticon-close-circle {
  display: none;
  position: absolute;
}
.list .item:hover .anticon-close-circle {
  display: inline;
}
.list .item .anticon-close-circle:hover + div {
  color: red;
}
.list .item > div > * {
  margin: 0;
  margin-right: 10px;
}
.inputsBox {
  display: flex;
  align-items: center;
  padding-left: 20px;
  padding-top: 10px;
  margin-right: 10px;
}
.inputsBox span {
  display: inline-block;
  width: 100px;
}
.ant-inputs2 {
  width: 100px;
  text-align: center;
}
.medicalList {
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;
}
.openHistory .medicalList > div {
  width: 33.333%;
}
.medicalList > div {
  width: 25%;
  margin: 5px 0;
}
.medicalList p {
  display: inline-block;
  width: 110px;
  text-align: right;
  margin-bottom: 0;
}
.medicalList span {
  display: none;
  margin-left: 15px;
}
.medicalList > div:hover span {
  display: inline-block;
}
.ant-input2 {
  width: 200px;
}
.thBox {
  transition: 0.2s all;
}
</style>


<script>
import {
  CloseCircleOutlined,
  CheckCircleOutlined
} from "@ant-design/icons-vue";
import { reactive } from "vue";
import { cloneDeep, template, } from "lodash-es";
import { RecordDetail, CustomerDetail, Save, SyndromeList, DiseaseList, AddReportItem, GetSetting, GetOperation, Send, GetReportDetail, UpdateSyndromeList, DeleteList, GetPulse, GetPrescriptionList, GetMedicineOption, AddMedical, UpdateMedical, DeleteMedical, UpdatePrescription, GetTakingMethods, AddPrescription, DeletePrescription, RecordList, RecordCopy, GetTemplate } from "/src/api/medicalRecord.js";
import { pinyin } from 'pinyin-pro';
import editCustomer from "/src/components/medicalRecord/editCustomer.vue";
import maizhenyi from "/src/components/medicalRecord/maizhenyi.vue";
import wuxing from "/src/components/medicalRecord/wuxing.vue";
import healthAssessment from "/src/components/medicalRecord/healthAssessment.vue";
import autoPrescription from "/src/components/medicalRecord/autoPrescription.vue";
import historyTable from "./historyTable.vue"
import recordHeader from "./recordHeader.vue"
import prescriptionTemplate from "./prescriptionTemplate.vue"
export default {
  components: {
    editCustomer,
    CloseCircleOutlined,
    CheckCircleOutlined,
    maizhenyi,
    wuxing,
    healthAssessment,
    autoPrescription,
    historyTable,
    recordHeader,
    prescriptionTemplate
  },
  name: "病历",
  data() {
    return {
      visible: false,
      visible2: false,
      visible3: false,
      visible4: false,
      visible5: false,
      recordList: [],
      template: "",
      openHistory: false,
      medicalRecordId: -1,
      medicalRecordUuid: "",
      medical: {
        id: undefined,
        count: 0,
      },
      prescriptionInfoList: [
      ],
      customerInfo: {
      },
      reportId: "",
      customerId: -1,
      data: {},
      inputs: {
        chiefComplaint: "",
        comment: "",
        pastHistory: "",
        presentIllnessHistory: "",
        syndrome: "",
        disease: "",
        tongue: "",
        leftCunType: "",
        leftCun: "",
        rightCunType: "",
        rightCun: "",
        leftGuanType: "",
        leftGuan: "",
        rightGuanType: "",
        rightGuan: "",
        leftChiType: "",
        leftChi: "",
        rightChiType: "",
        rightChi: "",
        tongue: "",
        fubingDiagnose: "",
        wmDiagnose: "",
        recipeTwo: "",
        recipeThree: "",
        recipeFour: "",
        recipeFive: "",
        recipeSix: "",
      },
      canCompare: false,
      savedTime: null,
      saveTimeout: null,
      syndromeOption: [],
      diseaseOption: [],
      medicineOption: [],
      syndromeList: [],
      diseaseList: [],
      showSyndromePop: false,
      showDiseasePop: false,
      setting: [],
      editSetting: [],
      details: [],
      takingMethodOption: [],
      operations: [],
      pulseOption: [],
      //控制症候群编辑的状态（编辑后不会更改）
      editSyndromeListData: {},
      editDiseaseListData: {},
      currentEdit: "",
      //用来上传更改后的症候群数据
      editDetails: [],
    };
  },
  created() { },
  mounted() {
    this.init()
  },
  activated() {

  },
  methods: {
    async init() {
      await this.getRecordDetail()
      this.getOptions()
      this.getOperation()
      this.getReportDetail()
      this.getPulseOption()
      this.getPrescriptionList()
      this.getRecordList()
      this.getTemplate()
    },
    //历史记录对比
    async getRecordList() {
      let uuid = window.location.hash.split("/").pop()
      let res = await RecordList({ customerId: this.data.customerId, excludedUuid: uuid, status: "Completed", pageSize: -1 })
      this.recordList = res.data.records
      console.log("RecordList", res.data);
      if (res.data?.records?.length > 0) {
        this.canCompare = true
      }
    },
    //获取病例详情
    async getRecordDetail() {
      let uuid = window.location.hash.split("/").pop()
      let res = await RecordDetail({ uuid });
      console.log("RecordDetail", res.data);
      this.inputs = { ...res.data };
      this.data = { ...res.data };

      this.getCustomerDetail(res.data.customer.uuid)

    },
    async getTemplate() {
      let uuid = window.location.hash.split("/").pop()
      let res = await GetTemplate({ uuid })
      console.log("getTemplate", res.data);
      this.template = res.data

    },
    async getCustomerDetail(uuid) {
      let res = await CustomerDetail({ uuid })
      this.customerInfo = res.data
      console.log("CustomerDetail", res.data);
    },
    async getReportDetail() {
      let medicalRecordId = this.data.id
      this.medicalRecordId = medicalRecordId
      this.medicalRecordUuid = this.data.uuid

      let res = await GetReportDetail({ medicalRecordId })
      console.log("GetReportDetail（处方外的数据）", res.data);

      //每条加上一个isEdit属性
      res.data.items?.forEach(item => {
        item.isEdit = false
      })
      this.syndromeList = res.data.items?.filter(item => item.category == "症候群")
      this.diseaseList = res.data.items?.filter(item => item.category == "疾病")
      this.reportId = res.data.id
    },
    async getPrescriptionList() {
      let res = await GetPrescriptionList({ includeItems: true, medicalRecordUuid: this.data.uuid })
      console.log("GetPrescriptionList（处方信息）", res.data);
      this.prescriptionInfoList = res.data.map(item => {
        item.isEdit = false
        item.showPrescribeBtn = false
        return item
      })
      for (const item of this.prescriptionInfoList) {
        item.takingMethodOption = await this.GetTakingMethodOption(item?.id)
      }

    },
    refreshCallback(data) {
      console.log("refreshCallback", data);
      if (data?.wuxing) {
        this.inputs.tcmDiagnose = data.wuxing
      }
      this.init()
      // this.getReportDetail()
    },
    async save() {
      let parmas = {
        id: this.data.id,
        ...this.findDifferences(this.data, this.inputs)
      }
      console.log(parmas);

      let res = await Save(parmas)
    },
    findDifferences(obj1, obj2) {
      let differences = {};

      // 获取所有需要检查的键（包括obj1和obj2中的键）
      let keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

      keys.forEach(key => {
        let val1 = obj1[key];
        let val2 = obj2[key];

        // 如果两个值都是对象且不是null，则递归比较
        if (typeof val1 === 'object' && val1 !== null && typeof val2 === 'object' && val2 !== null &&
          !Array.isArray(val1) && !Array.isArray(val2)) {
          let nestedDiff = findDifferences(val1, val2);
          if (Object.keys(nestedDiff).length > 0) { // 只有在存在差异时才添加
            differences[key] = nestedDiff;
          }
        }
        // 直接比较基本数据类型或数组
        else if (val1 !== val2) {
          differences[key] = val2;
        }
      });

      return differences;
    },
    getPinyinFirstInitials(str) {
      if (!str) return '';

      const result = pinyin(str, {
        pattern: 'first',   // 只获取拼音首字母
        toneType: 'none',      // 不要音调
        mode: 'normal',   // 普通模式（非智能分词）
      });

      // 处理返回结果（兼容数组和字符串两种结构）
      if (Array.isArray(result)) {
        return result.map(arr => arr[0]).join('').toLowerCase();
      } else if (typeof result === 'string') {
        return result.replace(/\s+/g, '').toLowerCase(); // 去空格
      }

      return '';
    },
    getPinyinInitials(str) {
      if (!str) return '';

      const result = pinyin(str, {
        toneType: 'none',      // 不要音调
        mode: 'normal',   // 普通模式（非智能分词）
      });

      // 处理返回结果（兼容数组和字符串两种结构）
      if (Array.isArray(result)) {
        return result.map(arr => arr[0]).join('').toLowerCase();
      } else if (typeof result === 'string') {
        return result.replace(/\s+/g, '').toLowerCase(); // 去空格
      }
      return '';
    },
    // filterOption 方法
    filterName(input, option) {
      // console.log(option);
      const label = option.value; // a-select-option 的显示文本
      const pinyinFirstInitials = this.getPinyinFirstInitials(label); // 获取该选项的拼音首字母
      const pinyinInitials = this.getPinyinInitials(label); // 获取该选项的拼音首字母
      const lowerInput = input.toLowerCase(); // 输入内容统一小写处理
      // console.log(pinyinInitials);

      // 匹配中文 或 拼音首字母
      return (
        label.toLowerCase().includes(lowerInput) ||
        pinyinFirstInitials.toLowerCase().includes(lowerInput) ||
        pinyinInitials.toLowerCase().includes(lowerInput)
      );
    },
    //获取症候群和疾病选项
    async getOptions() {
      let syndromeOption = await SyndromeList({ pageSize: -1 })
      let diseaseOption = await DiseaseList({ pageSize: -1 })

      // console.log("diseaseOption", diseaseOption);

      this.syndromeOption = syndromeOption.data.records
      this.diseaseOption = diseaseOption.data.records
    },
    handleChangePopconfirm(value, category) {
      this.showSyndromePop = false
      this.showDiseasePop = false
      let option;
      console.log(category);

      if (category == "症候群") {
        this.showSyndromePop = true
        option = "syndromeOption"
      } else if (category == "疾病") {
        this.showDiseasePop = true
        option = "diseaseOption"
      }
      let id = this[option].find(item => item.name == value).id
      this.getSetting(id, category)

    },
    async insertToList(category) {
      let id
      if (category === "症候群") {
        id = this.syndromeOption.find(item => item.name == this.inputs.syndrome).id
      } else if (category === "疾病") {
        id = this.diseaseOption.find(item => item.name == this.inputs.disease).id
      }
      let parmas = { reportId: this.reportId, category, projectId: id, projectName: this.inputs.disease, details: this.details }
      if (category === "症候群") {
        parmas.projectName = this.inputs.syndrome
      } else if (category === "疾病") {
        parmas.projectName = this.inputs.disease
      }
      let res = await AddReportItem(parmas)
      this.getReportDetail()
      this.showDiseasePop = false
      this.showSyndromePop = false
      if (category === "症候群") {
        this.inputs.syndrome = undefined
      } else if (category === "疾病") {
        this.inputs.disease = undefined
      }
    },
    async getSetting(projectId, category) {
      let res = await GetSetting({ projectId, category })
      this.setting = res.data
      console.log("this.setting", this.setting);

      this.details = res.data.map(item => {
        return {
          diagnosisName: item.diagnosisName,
          diagnosisInfo: undefined,
        }
      })


    },
    async getOperation() {
      let res = await GetOperation({ uuid: this.data.uuid })
      this.operations = res.data
    },
    async handleOperation(operation) {
      let flag = false
      this.prescriptionInfoList.forEach(element => {
        if (!element.dosageDays || !element.timesPerDay || !element.takingMethod) {
          flag = true
        }
      });
      if (flag) {
        this.$message.warning("请先完善处方信息")
        return
      }
      let res = await Send({ uuid: this.data.uuid, operation })
      if (res.errCode == 0) {
        this.$message.success("操作成功")
        this.init()
      }
    },
    //点击开始编辑
    editList(item, category) {
      //编辑时保存初始数据
      let editData;
      //下肢无力 程度：【严重】；
      let list;
      let listDataName;
      if (category == "症候群") {
        editData = this.editSyndromeListData
        listDataName = "editSyndromeListData"
        list = this.syndromeList
      } else if (category == "疾病") {
        editData = this.editDiseaseListData
        listDataName = "editDiseaseListData"
        list = this.diseaseList
      }


      //this.editDetails没有id则新增

      // if () {
      //   flag = true
      // }

      //判断是否在编辑另一个（症候群、疾病）的记录
      if (category != this.currentEdit && this.currentEdit) {
        this.$message.warning("请先保存" + this.currentEdit + "编辑的记录")
        return
      }
      this.currentEdit = category

      if (item.isEdit) {
        return
      }
      // console.log("this.editDetails", this.editDetails);
      // console.log("editData.details", editData);

      //undefinde状态则无视
      let flag = false

      console.log("editData", editData);
      console.log("editData.details", editData.details);
      console.log("编辑状态的数据：this.editDetails", this.editDetails);
      if (JSON.stringify(editData) !== '{}') {
        let newItem = this.editDetails.find(item => item.id == undefined)
        console.log("newItem", newItem);
        if (newItem && newItem.diagnosisInfo != undefined) {
          flag = true
        }
      }


      let flag2 = this.deepEqual(this.editDetails, this.editSyndromeListData.details)
      let flag3 = this.deepEqual(this.editDetails, this.editDiseaseListData.details)

      // console.log("flag", flag);

      if (JSON.stringify(editData) !== '{}' && flag && !flag2 && !flag3) {
        this.$message.warning("记录已更改，请保存后再编辑")
        return
      }

      //编辑的初始数据
      this[listDataName] = item
      list.forEach(item => {
        item.isEdit = false
      })
      item.isEdit = true
      this.getEditSetting(item.id, category, item)
    },
    deepEqual(obj1, obj2) {
      // 如果两个对象引用相同，则它们是相同的对象
      if (obj1 === obj2) return true;

      // 检查不是null并且都是对象或都是数组
      if (obj1 == null || typeof obj1 != "object" ||
        obj2 == null || typeof obj2 != "object") {
        return false;
      }

      let keysA = Object.keys(obj1), keysB = Object.keys(obj2);

      // 检查两个对象具有相同的key数量
      if (keysA.length != keysB.length) return false;

      // 检查每个key是否存在于两个对象中且对应的值相等
      for (let key of keysA) {
        if (!keysB.includes(key) || !this.deepEqual(obj1[key], obj2[key])) return false;
      }

      return true;
    },
    //获取列表单行的设置选项
    async getEditSetting(projectId, category) {
      this.editDetails = []
      let res = await GetSetting({ projectId, category })
      let editData
      let list
      // console.log("getSetting", res);
      if (category == "症候群") {
        editData = this.editSyndromeListData
        list = this.syndromeList
      } else if (category == "疾病") {
        editData = this.editDiseaseListData
        list = this.diseaseList
      }
      //当前点击的编辑内所有的设置项
      this.editSetting = res.data
      console.log("res.data", res.data);
      console.log("list", list);
      console.log("初始数据：editData", editData);

      //初始值
      this.editDetails = res.data.map(item => {
        // var value = {
        //   id: list.find(item2 => item2.id == editData.id).details.find(item2 => item2.diagnosisName == item.diagnosisName).id,
        //   diagnosisName: item.diagnosisName,
        //   diagnosisInfo: list.find(item2 => item2.id == editData.id).details.find(item2 => item2.diagnosisName == item.diagnosisName).diagnosisInfo,
        // }
        var value = {
          id: list.find(item2 => item2.id == editData.id).details.find(item2 => item2.diagnosisName == item.diagnosisName)?.id,
          diagnosisName: item.diagnosisName,
          diagnosisInfo: list.find(item2 => item2.id == editData.id).details.find(item2 => item2.diagnosisName == item.diagnosisName)?.diagnosisInfo,
        }

        // console.log("value", value);


        return value
      })

      list.forEach(item => {
        this.editDetails.forEach(item2 => {
          if (item.diagnosisName == item2.diagnosisName) {
            item2.diagnosisInfo = item?.diagnosisInfo
          }
        })
      })

    },
    async updateList(item, parent) {

      event.stopPropagation();
      // console.log("this.editDetails", this.editDetails);
      // console.log("this.editSyndromeListData", this.editSyndromeListData);

      // let id = item.id
      for (const item of this.editDetails) {
        if (item.id) {
          await UpdateSyndromeList(item);
        } else {
          console.log(item);
          delete item.id
          item.itemId = parent.id

          await UpdateSyndromeList(item);
        }
      }
      parent.isEdit = false
      this.currentEdit = ""
      this.editSyndromeListData = {}
      this.editDiseaseListData = {}
      console.log("item", item);
      this.getReportDetail()

    },
    async deleteList(id) {
      // 阻止事件冒泡
      event.stopPropagation();

      this.editSyndromeListData = {}
      let res = await DeleteList({ id })
      this.getReportDetail()
    },
    resetList(category) {
      let editData;
      if (category == "症候群") {
        editData = this.editSyndromeListData
      } else if (category == "疾病") {
        editData = this.editDiseaseListData
      }
      this.editDetails = this.editDetails.map(item => {
        item.diagnosisInfo = editData.details.find(item2 => item2.diagnosisName == item.diagnosisName)?.diagnosisInfo
        return item
      })
    },
    toMaiZhenYi() {
      this.visible2 = true
      this.customerId = this.customerInfo.id
    },
    toHealthAssessment() {
      this.visible4 = true
      this.customerId = this.customerInfo.id
    },
    async maizhenyiCallback(value) {

      this.inputs = { ...this.inputs, ...value }
      let parmas = {
        ...value,
        id: this.data.id,
      }
      console.log("value", value);
      let res = await Save(parmas)

    },
    async healthAssessmentCallBack() {
      this.getReportDetail()
    },
    compareCase() {
      console.log(this.customerInfo);
      this.openHistory = !this.openHistory
    },
    handleChangePulse(type) {

      if (this.inputs[type + "Type"]) {
        let value = this.inputs[type]
        if (value) {
          this.inputs[type] += "," + this.inputs[type + "Type"]
        } else {
          this.inputs[type] = this.inputs[type + "Type"]
        }
        setTimeout(() => {
          this.inputs[type + "Type"] = undefined
        }, 50);
      }


    },
    async getPulseOption() {
      let res = await GetPulse()
      this.pulseOption = res.data
    },
    async wuxingCallback(value) {
      // value = ['长', '弦', '滑', '迟', '细']
      this.inputs.tcmDiagnose = value.join(",")

      let parmas = {
        id: this.data.id,
        tcmDiagnose: this.inputs.tcmDiagnose,
      }
      console.log(parmas);
      let res = await Save(parmas)
    },
    async addPrescriptionInfo() {
      let parmas = { medicalRecordId: this.data.id, category: "Caoyao" }
      if (this.template == "Simple_Futie") {
        parmas.takingMethod = "敷贴"
      }
      let res = await AddPrescription(parmas)
      console.log("AddPrescription", res.data);

      if (res.errCode == 0) {
        await this.getPrescriptionList()
        let index = this.prescriptionInfoList.length - 1
        this.$refs.prescriptionTemplate.prescribe(res.data, index)

      } else {
        this.$message.error("添加失败")
      }
    },
    async changeMedical(id, quantity) {
      // console.log(id, quantity);
      clearTimeout(this.saveTimeout);
      this.saveTimeout = setTimeout(async () => {
        let res = await UpdateMedical({ id, quantity })
        if (res.errCode != 0) {
          this.$message.error("修改失败")
        } else {
          this.$message.success("修改成功")
        }
      }, 2000)
    },
    async GetTakingMethodOption(id) {
      let res = await GetTakingMethods({ prescriptionId: id })
      // console.log("GetTakingMethodOption", res.data);

      return res.data
    },
    async changePrescription(item) {

      clearTimeout(this.saveTimeout);
      let parmas = {
        id: item.id,
        dosageDays: item.dosageDays,
        timesPerDay: item.timesPerDay,
        takingMethod: item.takingMethod,
        description: item.description,
      }

      // parmas[type] = value
      this.saveTimeout = setTimeout(async () => {
        let res = await UpdatePrescription(parmas)
        if (res.errCode != 0) {
          this.$message.error("修改失败")
        }
      }, 2000)
    },
    changeShowBtn(item) {
      this.prescriptionInfoList.forEach(item => {
        item.showPrescribeBtn = false
      })
      item.showPrescribeBtn = true
    },
    async copy(newUuid) {
      let uuid = window.location.hash.split("/").pop()
      let res = await RecordCopy({ destMrUuid: uuid, srcMrUuid: newUuid })
      if (res.errCode == 0) {
        this.$message.success("成功")
        this.init()
      }
    },
    async copyPrescription(newUuid) {
      let uuid = window.location.hash.split("/").pop()
      let res = await RecordCopy({ destMrUuid: uuid, srcPUuids: [newUuid] })
      if (res.errCode == 0) {
        this.$message.success("成功")
        this.init()
      }
    }
  }
};
</script>


